import React, { useEffect } from "react";
import { useState } from "react";
import { BetsExpandCollapseContext } from "./BetsExpandCollapseContext";


function BetsExpandCollapse(props) {
    const betsExpandCollapseContext = React.useContext(BetsExpandCollapseContext);
    const [expand, setExpand] = useState(betsExpandCollapseContext.isAllBetsCollapsed());

    useEffect(() => {
        setExpand(betsExpandCollapseContext.isAllBetsCollapsed())
     }, [betsExpandCollapseContext]);

    return (
            <div className="arrow-container" id="arrow-collapse-odds" onClick={betsExpandCollapseContext.toggleAllBetsCollapsed}>
                <span className={`arrow arrow-${expand?'expand':'collapse'}`}></span>
            </div>
    )

}

export default BetsExpandCollapse;